import Analytics from '@aws-amplify/analytics';
import Auth from '@aws-amplify/auth';


const amplifyConfig = {
  Auth: {
    identityPoolId: 'us-east-1:6f88ae8d-de42-42f5-b22e-fd77d7bc04f5',
    region: 'us-east-1'
  }
}
//Initialize Amplify
Auth.configure(amplifyConfig);

const analyticsConfig = {
  AWSPinpoint: {
        // Amazon Pinpoint App Client ID
        appId: '6509d456a2724fb1886e20db6384ee34',
        // Amazon service region
        region: 'us-east-1',
        mandatorySignIn: false,
  }
}

Analytics.configure(analyticsConfig)

export function AutoTrack() {
    Analytics.autoTrack('pageView', {
        // REQUIRED, turn on/off the auto tracking
        enable: true,
        // OPTIONAL, the event name, by default is 'pageView'
        eventName: 'pageView',
        // OPTIONAL, the attributes of the event, you can either pass an object or a function 
        // which allows you to define dynamic attributes
        attributes: {
            attr: 'attr'
        },
        // when using function
        // attributes: () => {
        //    const attr = somewhere();
        //    return {
        //        myAttr: attr
        //    }
        // },
        // OPTIONAL, by default is 'multiPageApp'
        // you need to change it to 'SPA' if your app is a single-page app like React
        type: 'SPA',
        // OPTIONAL, the service provider, by default is the Amazon Pinpoint
        provider: 'AWSPinpoint',
        // OPTIONAL, to get the current page url
        getUrl: () => {
            // the default function

            if (window.location.pathname.includes("share")) {
                return window.location.origin + "/share";
            } else if (window.location.pathname.includes("view")) {
                return window.location.origin + "/view";
            }

            return window.location.origin + window.location.pathname;
        }
    });

    

    Analytics.autoTrack('event', {
        // REQUIRED, turn on/off the auto tracking
        enable: true,
        // OPTIONAL, events you want to track, by default is 'click'
        events: ['click'],
        // OPTIONAL, the prefix of the selectors, by default is 'data-amplify-analytics-'
        // in order to avoid collision with the user agent, according to https://www.w3schools.com/tags/att_global_data.asp
        // always put 'data' as the first prefix
        selectorPrefix: 'data-amplify-analytics-',
        // OPTIONAL, the service provider, by default is the Amazon Pinpoint
        provider: 'AWSPinpoint',
        // OPTIONAL, the default attributes of the event, you can either pass an object or a function 
        // which allows you to define dynamic attributes
        attributes: {
            attr: 'attr'
        }
        // when using function
        // attributes: () => {
        //    const attr = somewhere();
        //    return {
        //        myAttr: attr
        //    }
        // }
    });

//     <!-- you want to track this button and send an event when it is clicked -->
// <button
//     data-amplify-analytics-on='click'
//     data-amplify-analytics-name='click'
//     data-amplify-analytics-attrs='attr1:attr1_value,attr2:attr2_value'
// />
}

export function RecordEvent(eventName) {

    Analytics.record({name: eventName});
}
